module.exports = __webpack_public_path__ + "img/904656.74fdb058.jpg";